export const ROWS =20, COLS =20, CELL = 30;
export const BODY = 1, FOOD = 2;
export const START = 44;
export const KEYS = {left: 37, up: 38, right: 39, down: 40};
export const DIRS = {37: true, 38: true, 39: true, 40: true};